import { createContext } from 'react';

// @ts-ignore
export const ErrorBoundaryContext = createContext<{
  onError?: ({ error, appZone }: { error?: Error; appZone: string }) => void;
}>();
